/**
 * FHL Scheduling (self-hosted Cal.diy) constants.
 * The Cal.diy instance lives at cal.fhl.one; Origin wraps its event types in
 * co-branded public pages at {origin}/book/{handle}/{slug}, where handle is
 * the owner's Cal username (users/{uid}.bookingHandle) so slugs only need to
 * be unique per user.
 */

export const CAL_BASE_URL = 'https://cal.fhl.one';

/** Public co-branded page URL for a booking page row (handle + slug). */
export function buildPublicBookingUrl(handle, slug, extraParams = {}) {
  const base = `${window.location.origin}/book/${handle}/${slug}`;
  const params = new URLSearchParams(
    Object.entries(extraParams).filter(([, v]) => v !== undefined && v !== null && v !== '')
  ).toString();
  return params ? `${base}?${params}` : base;
}

/** Derive the "username/event" path Cal.diy's embed API expects from a full event URL. */
export function calLinkFromEventUrl(calEventUrl) {
  if (!calEventUrl) return '';
  try {
    const url = new URL(calEventUrl);
    return url.pathname.replace(/^\/+|\/+$/g, '');
  } catch (e) {
    return String(calEventUrl).replace(/^https?:\/\/[^/]+\//i, '').replace(/^\/+|\/+$/g, '');
  }
}
